<template>
  <div class="partner-page">
    <!-- 模块1：Banner -->
    <section class="banner-section">
      <div class="banner-bg">
        <img src="/banner-AI合作伙伴背景图.jpg" alt="" class="banner-bg-img" />
      </div>
      <div class="pc-wrap banner-inner">
        <div class="banner-grid">
          <AnimatedSection>
            <h1 class="banner-title">千橙AI合作伙伴计划</h1>
            <h2 class="banner-subtitle">携手共赢 AI未来</h2>
            <p class="banner-desc">
              携手汇通数科，共享AI时代红利。我们提供全方位产品、技术与运营支持，助您快速切入AI赛道，实现业务增长与价值共创。
            </p>
            <a href="javascript:void(0)" class="cta-btn cta-black" @click="openContact">
              <span class="cta-text">立即申请合作</span>
              <LucideIcon name="arrow-right" :size="16" :stroke-width="2" class="cta-arrow" />
            </a>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块2：AI智能体矩阵场景解决方案 -->
    <section class="solutions-section">
      <div class="pc-wrap">
        <AnimatedSection>
          <div class="section-head">
            <h2 class="section-title">AI智能体矩阵场景解决方案</h2>
            <p class="section-desc">
              基于千橙云AI智能大模型，打造覆盖零售全场景的AI智能体矩阵，为企业提供一站式智能化升级解决方案
            </p>
          </div>
        </AnimatedSection>
        <div class="solution-list">
          <AnimatedSection v-for="(item, i) in solutions" :key="i" :delay="i * 100">
            <div class="solution-card">
              <!-- 左半边：标题+介绍+标签 -->
              <div class="solution-info">
                <div class="solution-head">
                  <div class="solution-icon" :style="{ backgroundColor: item.color }">
                    <LucideIcon :name="item.icon" :size="24" :stroke-width="2" />
                  </div>
                  <h3 class="solution-name">{{ item.title }}</h3>
                </div>
                <p class="solution-desc">{{ item.desc }}</p>
                <div class="solution-tags">
                  <span v-for="(tag, j) in item.tags" :key="j" class="solution-tag">
                    <LucideIcon name="check" :size="14" :stroke-width="2.5" />
                    {{ tag }}
                  </span>
                </div>
              </div>
              <!-- 右半边：客户案例图+遮罩+内容 -->
              <div class="solution-case">
                <img :src="item.caseImage" :alt="item.caseTitle" class="case-img" />
                <div class="case-overlay"></div>
                <div class="case-content">
                  <h4 class="case-title">{{ item.caseTitle }}</h4>
                  <p class="case-desc">{{ item.caseDesc }}</p>
                  <div class="case-stats">
                    <div v-for="(stat, k) in item.caseStats" :key="k">
                      <div class="case-stat-value">{{ stat.value }}</div>
                      <div class="case-stat-label">{{ stat.label }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 合作伙伴定位 -->
    <section class="position-section">
      <div class="pc-wrap position-wrap">
        <AnimatedSection>
          <div class="position-head">
            <h2 class="section-title">合作伙伴定位</h2>
            <p class="position-head-desc">
              明确分工，携手共赢。您负责客户链接和拓展，我们负责产品交付和服务
            </p>
          </div>
        </AnimatedSection>

        <!-- 合作双方 - 桌面端 -->
        <div class="position-desktop">
          <!-- 左侧：3条（弹性宽度） -->
          <div class="position-side position-side-left">
            <div class="position-list">
              <AnimatedSection v-for="(item, i) in partnerLeftItems" :key="'lp-' + i" :delay="i * 100">
                <div class="position-item">
                  <LucideIcon name="check" :size="20" :stroke-width="2.5" class="position-check" :style="{ color: item.color }" />
                  <span class="position-item-text">{{ item.text }}</span>
                </div>
              </AnimatedSection>
            </div>
          </div>

          <!-- 中间：圆圈 + 加号 + 圆圈 -->
          <div class="position-center">
            <!-- 合作伙伴：椭圆 + 圆圈 -->
            <div class="circle-wrap">
              <div class="circle-glow circle-glow-purple"></div>
              <div class="partner-circle circle-purple">
                <span class="circle-name">合作伙伴</span>
                <span class="circle-sub">PARTNER</span>
              </div>
            </div>

            <!-- 加号 -->
            <div class="plus-wrap">
              <div class="plus-circle">
                <span>+</span>
              </div>
            </div>

            <!-- 汇通数科：圆圈 + 椭圆 -->
            <div class="circle-wrap">
              <div class="circle-glow circle-glow-blue"></div>
              <div class="partner-circle circle-blue">
                <span class="circle-name">汇通数科</span>
                <span class="circle-sub">Hitone Datatech.</span>
              </div>
            </div>
          </div>

          <!-- 右侧：3条（弹性宽度） -->
          <div class="position-side position-side-right">
            <div class="position-list">
              <AnimatedSection v-for="(item, i) in partnerRightItems" :key="'rp-' + i" :delay="i * 100">
                <div class="position-item">
                  <LucideIcon name="check" :size="20" :stroke-width="2.5" class="position-check" :style="{ color: item.color }" />
                  <span class="position-item-text">{{ item.text }}</span>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>

        <!-- 合作双方 - 移动端 -->
        <div class="position-mobile">
          <!-- 合作伙伴的3条 -->
          <div class="mobile-list">
            <AnimatedSection v-for="(item, i) in partnerLeftItems" :key="'p-' + i" :delay="i * 80">
              <div class="mobile-item">
                <LucideIcon name="check" :size="20" :stroke-width="2.5" class="position-check" :style="{ color: item.color }" />
                <span class="mobile-item-text">{{ item.text }}</span>
              </div>
            </AnimatedSection>
          </div>

          <!-- 合作伙伴圆圈 -->
          <AnimatedSection>
            <div class="mobile-circle circle-purple">
              <span class="circle-name">合作伙伴</span>
              <span class="circle-sub">PARTNER</span>
            </div>
          </AnimatedSection>

          <!-- 加号 -->
          <div class="mobile-plus">
            <div class="mobile-plus-circle">
              <span>+</span>
            </div>
          </div>

          <!-- 汇通数科圆圈 + 3条 -->
          <div class="mobile-hitone">
            <AnimatedSection :delay="100">
              <div class="mobile-circle circle-blue">
                <span class="circle-name">汇通数科</span>
                <span class="circle-sub">Hitone Datatech.</span>
              </div>
            </AnimatedSection>

            <div class="mobile-list">
              <AnimatedSection v-for="(item, i) in partnerRightItems" :key="'h-' + i" :delay="i * 80">
                <div class="mobile-item">
                  <LucideIcon name="check" :size="20" :stroke-width="2.5" class="position-check" :style="{ color: item.color }" />
                  <span class="mobile-item-text">{{ item.text }}</span>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>

        <!-- 四类合作对象 -->
        <AnimatedSection>
          <div class="partner-types-head">
            <h3>四类合作对象</h3>
            <div class="types-divider"></div>
          </div>
        </AnimatedSection>
        <div class="partner-types-grid">
          <AnimatedSection v-for="(item, i) in partnerTypes" :key="i" :delay="i * 80">
            <div class="partner-type-card">
              <div class="partner-type-imgbox">
                <img :src="item.image" :alt="item.title" />
              </div>
              <div class="partner-type-name">
                <h4>{{ item.title }}</h4>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 合作伙伴赋能 -->
    <section class="empower-section">
      <div class="pc-wrap">
        <AnimatedSection>
          <div class="section-head empower-head">
            <h2 class="section-title">合作伙伴赋能</h2>
            <p class="section-desc narrow-desc">
              全方位赋能支持，从授权到交付，助力合作伙伴快速启动业务、持续增长
            </p>
          </div>
        </AnimatedSection>

        <!-- 主内容区域 -->
        <div class="empower-main">
          <!-- 椭圆背景 -->
          <div class="empower-ellipse"></div>

          <!-- 向上箭头 -->
          <div class="empower-arrow">
            <img src="/形状结合.png" alt="" />
          </div>

          <!-- 5个卡片 - 弧形排列 -->
          <div class="empower-grid">
            <AnimatedSection
              v-for="(item, i) in empowerCards"
              :key="i"
              :delay="i * 80"
              :class="'empower-offset-' + item.offset"
            >
              <div class="empower-card">
                <div class="empower-icon" :style="{ color: item.color }">
                  <svg v-if="item.icon === 'award'" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 5h-2V3H7v2H5C3.9 5 3 5.9 3 7v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" />
                  </svg>
                  <svg v-else-if="item.icon === 'book'" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z" />
                  </svg>
                  <svg v-else-if="item.icon === 'wrench'" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" />
                  </svg>
                  <svg v-else-if="item.icon === 'coins'" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" />
                  </svg>
                  <svg v-else-if="item.icon === 'headphones'" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 3a9 9 0 0 0-9 9v7c0 1.1.9 2 2 2h4v-8H5v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h-4v8h4c1.1 0 2-.9 2-2v-7a9 9 0 0 0-9-9z" />
                  </svg>
                </div>
                <h4>{{ item.title }}</h4>
                <p>{{ item.desc }}</p>
              </div>
            </AnimatedSection>
          </div>

          <!-- 赋能按钮 - 中心与椭圆下边对齐 -->
          <div class="empower-badge">赋能</div>
        </div>
      </div>
    </section>

    <!-- 合作伙伴收益 -->
    <section class="benefit-section">
      <div class="pc-wrap">
        <AnimatedSection>
          <div class="section-head">
            <h2 class="section-title">合作伙伴收益</h2>
            <p class="section-desc narrow-desc">
              四重收益，一次拓客，长期收益。多元化收益结构，助力合作伙伴实现持续增长
            </p>
          </div>
        </AnimatedSection>

        <div class="benefit-grid">
          <AnimatedSection v-for="(item, i) in benefitCards" :key="i" :delay="i * 80">
            <div class="benefit-card">
              <div>
                <div class="benefit-icon" :style="{ backgroundColor: item.color }">
                  <LucideIcon :name="item.icon" :size="24" :stroke-width="2" />
                </div>
                <h4>{{ item.title }}</h4>
                <p class="benefit-desc">{{ item.desc }}</p>
              </div>
              <div class="benefit-tag-wrap">
                <div class="benefit-tag" :style="{ backgroundColor: item.color + '15', color: item.color }">
                  {{ item.tag }}
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块10：CTA -->
    <section class="cta-section">
      <!-- 背景图 -->
      <div class="cta-bg">
        <img src="/底部背景AI效果营销.jpg" alt="" />
      </div>
      <div class="pc-wrap cta-content">
        <AnimatedSection>
          <h2 class="cta-title">期待与您合作 · 共创价值 共享成长</h2>
          <p class="cta-desc">
            抓住AI时代机遇，携手汇通数科，开启财富新篇章
          </p>
          <div class="cta-btn-wrap">
            <a href="javascript:void(0)" class="cta-btn cta-dark" @click="openContact">
              <span class="cta-text">立即申请成为合作伙伴</span>
              <LucideIcon name="arrow-right" :size="16" :stroke-width="2" class="cta-arrow" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  </div>
</template>

<script>
import AnimatedSection from '@/components/AnimatedSection.vue'
import LucideIcon from '@/components/LucideIcon.vue'

export default {
  name: 'PartnerContent',
  components: { AnimatedSection, LucideIcon },
  data() {
    return {
      // AI智能体矩阵场景解决方案
      solutions: [
        {
          icon: 'shopping-cart',
          color: '#3B82F6',
          title: 'AI私域商城方案',
          desc: 'AI私域商城+1件代发供应链，帮助私域商城高效增长。零代码+自然语言完成网站设计和搭建，AI自动上架、营销策划、选品推荐，实现公转私全域获客。',
          tags: ['AI建站', 'AI选品', 'AI营销', '智能获客', '社群运营', '数据分析'],
          caseTitle: '安徽本地老酒企',
          caseImage: '/合作伙伴-AI私域商城方案.jpg',
          caseStats: [
            { value: '150%+', label: '单店月均销量增长' },
            { value: '70%', label: '市场费用降低' },
            { value: '65%', label: '社群月活率' }
          ],
          caseDesc: '打造门店新零售模式，构建「店-大C-用户」三层架构。沉淀用户数据画像分类，实现精准分层营销。AI生成策划内容、社群标准话术，搭配LBS智能匹配门店，接入总部中央直播+多店同步引流。六安专场2.5h GMV达11.5万。'
        },
        {
          icon: 'gift',
          color: '#8B5CF6',
          title: 'AI企业福利商城方案',
          desc: '自建福利商城平台，服务自己员工，并向外输出能力服务其他企业。10万+商品库，支持1件代发，覆盖B2B交易、企业福利团购、O2O服务、B2C福利兑换等多元场景。',
          tags: ['10万+商品', '1件代发', 'API接口', 'B2B2C', '福利兑换', '企业团购'],
          caseTitle: '某上市公司',
          caseImage: '/合作伙伴-AI企业福利商城方案.jpg',
          caseStats: [
            { value: '2亿+', label: 'C端用户规模' },
            { value: '500%', label: '销售规模增长' },
            { value: '10%', label: '采购成本下降' }
          ],
          caseDesc: '自建福利商城平台服务内部员工，同时向外输出能力服务其他企业。实现人效提升10万+，库存下降至0，外部服务利润率提升5%。打造企业福利生态闭环，实现降本增效与增值服务双收益。'
        },
        {
          icon: 'video',
          color: '#06B6D4',
          title: 'AI私域直播解决方案',
          desc: '通过中央直播、帮助连锁门店，提升人效和坪效实现利润、规模双增长。总部统一直播，多店同步引流，支持批采和1件代发，解决门店直播人才匮乏、运营成本高的痛点。',
          tags: ['中央直播', '多店联播', 'AI主播', '供应链支持', '运营赋能', '流量策略'],
          caseTitle: '区域连锁品牌',
          caseImage: '/合作伙伴-AI私域直播解决方案.jpg',
          caseStats: [
            { value: '3倍', label: '人效提升' },
            { value: '200%', label: '坪效增长' },
            { value: '50+', label: '门店同步直播' }
          ],
          caseDesc: '总部搭建中央直播间，统一商品、主播、运营体系，50+门店同步联播。解决门店"张不开嘴、讲不清品、动不了手"三大难题。+供应链+AI+运营三位一体，实现利润与规模双增长。'
        },
        {
          icon: 'users',
          color: '#3B82F6',
          title: '零售企业AI员工方案',
          desc: '为零售企业经营过程中，配置16个岗位的数字员工辅助工作，助力降本提效。覆盖导购、客服、营销、运营、数据分析等核心岗位，7×24小时不间断服务。',
          tags: ['16个岗位', '数字员工', '7×24服务', '降本提效', '智能导购', '自动运营'],
          caseTitle: '大型零售连锁',
          caseImage: '/合作伙伴-零售企业AI员工方案.jpg',
          caseStats: [
            { value: '60%', label: '人力成本降低' },
            { value: '3倍', label: '服务效率提升' },
            { value: '95%', label: '客户满意度' }
          ],
          caseDesc: '部署16个岗位数字员工，覆盖门店运营全流程。AI智能导购提升转化率，智能客服7×24小时响应，自动营销提升复购率，数据分析辅助决策。实现人力成本大幅降低，服务质量与效率显著提升。'
        }
      ],

      // 四大核心优势（源文件数据，原样保留）
      capabilities: [
        {
          icon: 'layers',
          title: '一站式创作',
          desc: '剧本、生图、生视频、配音，不再切来切去、到处倒数据；从选题到出稿一处做完，效率翻倍。'
        },
        {
          icon: 'zap',
          title: '零门槛 · 即开即用',
          desc: '注册即可上手，无需复杂配置；提个需求就能出作品，不用学提示词、不啃教程，小白也能用。'
        },
        {
          icon: 'shield-check',
          title: '稳定 · 安全 · 放心用',
          desc: '长期稳定运行，高峰时段也流畅不卡；内容经过安全审核，合规有保障，商业创作踏实放心。'
        },
        {
          icon: 'sparkles',
          title: '智能调度 · 效果更佳',
          desc: '聚合主流大模型，按你的创作内容自动选对模型，效果始终在线；不用钻研参数、反复试错，省心省力，出片更快。'
        }
      ],

      // 三步构建强大AI应用（源文件数据，原样保留）
      buildSteps: [
        {
          num: '01',
          icon: 'settings',
          title: '统一配置',
          enTitle: 'CONFIGURE',
          desc: '在控制台完成基础设置',
          features: ['API 密钥管理', '积分额度分配', '模型范围选择', 'IP 白名单设置']
        },
        {
          num: '02',
          icon: 'route',
          title: '轻松连接',
          enTitle: 'CONNECT',
          desc: '标准 API 格式快速接入',
          features: ['标准 OpenAI 兼容格式', '无需改代码切换模型', '多语言 SDK 支持', '详细接入文档']
        },
        {
          num: '03',
          icon: 'monitor',
          title: '智能监控',
          enTitle: 'MONITOR',
          desc: '实时掌握运行状态',
          features: ['统一仪表盘', '调用性能追踪', '成本趋势分析', '异常告警通知']
        }
      ],

      // 积分计费灵活透明（源文件数据，原样保留）
      advantages: [
        { title: '灵活选购套餐', desc: '按需选购积分额度，支持多种规格组合，满足不同阶段创作与业务需求。', icon: 'package' },
        { title: '按量扣减', desc: '每次创作按实际消耗实时扣减，精准计量，拒绝浪费。', icon: 'coins' },
        { title: '有效期灵活设定', desc: '支持按年或月设定有效周期，有效期内随时使用，到期前支持无缝续购。', icon: 'calendar' },
        { title: '用量实时可查', desc: '积分余额与消耗明细实时更新，支持按创作场景、模型维度查询明细账单。', icon: 'bar-chart-3' }
      ],

      // 交付方式（源文件数据，原样保留）
      deliveryModes: [
        {
          icon: 'cloud',
          title: 'SaaS订阅版',
          subtitle: 'STARTER',
          features: ['快速开通，无需部署', '按席位/Token计费', '标准功能全包含', '持续迭代升级'],
          suitable: '适合：中小企业/团队',
          recommended: false
        },
        {
          icon: 'server',
          title: '一体机私有化',
          subtitle: 'PROFESSIONAL',
          features: ['本地算力+预置模型', '即开即用，数据不出门', '完整企业级管控', '满足数据主权要求'],
          suitable: '适合：中大型企业',
          recommended: true
        },
        {
          icon: 'users',
          title: 'FDE定制服务',
          subtitle: 'ENTERPRISE',
          features: ['驻场专家+数字员工定制', '业务结果承诺', '飞轮机制持续优化', '行业标杆共建'],
          suitable: '适合：集团企业/行业标杆',
          recommended: false
        }
      ],

      // 合作伙伴定位 - 双方分工
      partnerLeftItems: [
        { text: '负责客户链接和拓展', color: '#8B5CF6' },
        { text: '本地市场深耕与客户关系维护', color: '#8B5CF6' },
        { text: '行业资源整合与商机挖掘', color: '#8B5CF6' }
      ],
      partnerRightItems: [
        { text: '负责产品交付和服务', color: '#3B82F6' },
        { text: '技术研发与产品迭代', color: '#3B82F6' },
        { text: '运营支持与培训赋能', color: '#3B82F6' }
      ],

      // 四类合作对象
      partnerTypes: [
        { title: 'OPC 产业园运营商', image: '/合作伙伴1-OPC产业园运营商.jpg' },
        { title: 'AI 智能体公司', image: '/合作伙伴2-AI智能体公司.jpg' },
        { title: 'AI 应用培训公司', image: '/合作伙伴3-AI应用培训公司.jpg' },
        { title: 'SaaS 代理商', image: '/合作伙伴4- SaaS代理商.jpg' }
      ],

      // 合作伙伴赋能 - 5个卡片弧形排列
      empowerCards: [
        { icon: 'award', title: '给授权、有背书', desc: '官方授权认证', color: '#8B5CF6', offset: 0 },
        { icon: 'book', title: '给方法、快上手', desc: '标准化方法论', color: '#3B82F6', offset: 1 },
        { icon: 'wrench', title: '给工具、好拓客', desc: '完善工具体系', color: '#06B6D4', offset: 2 },
        { icon: 'coins', title: '给政策、高收益', desc: '丰厚回报政策', color: '#6366F1', offset: 1 },
        { icon: 'headphones', title: '给交付、更轻松', desc: '全程交付支持', color: '#818CF8', offset: 0 }
      ],

      // 合作伙伴收益
      benefitCards: [
        { icon: 'graduation-cap', title: '培训收益', tag: 'AI培训费分润', desc: 'AI培训费分润，通过开展AI应用培训课程，获取培训服务收益', color: '#8B5CF6' },
        { icon: 'monitor', title: '软件收益', tag: '软件订阅分润', desc: '软件订阅分润，客户订阅AI产品获取持续的软件服务收益', color: '#3B82F6' },
        { icon: 'zap', title: '消耗收益', tag: 'Token消耗分润', desc: 'Token和供应链消耗分润，客户使用量越大收益越高', color: '#06B6D4' },
        { icon: 'trending-up', title: '政策收益', tag: '政策补贴激励', desc: '算力补贴、AI转型等激励，享受政府及平台政策扶持', color: '#818CF8' }
      ]
    }
  },
  methods: {
    openContact() {
      this.$root.$emit('openContactUs', '千橙AI合作伙伴计划')
    }
  }
}
</script>

<style scoped>
/* ---------- 通用容器（对应 mx-auto max-w-[1200px] px-6 lg:px-8） ---------- */
.pc-wrap {
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;
}
@media (min-width: 1024px) {
  .pc-wrap {
    padding-left: 32px;
    padding-right: 32px;
  }
}

/* ---------- 通用区块标题 ---------- */
.section-head {
  text-align: center;
  margin-bottom: 48px;
}
@media (min-width: 768px) {
  .section-head {
    margin-bottom: 64px;
  }
}
.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin-bottom: 12px;
  line-height: 1.2;
}
@media (min-width: 768px) {
  .section-title {
    font-size: 36px;
  }
}
.section-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
  line-height: 1.625;
}
@media (min-width: 768px) {
  .section-desc {
    font-size: 16px;
  }
}
.narrow-desc {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

/* ---------- 模块1：Banner ---------- */
.banner-section {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  height: auto;
}
@media (min-width: 768px) {
  .banner-section {
    height: 600px;
  }
}
.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
@media (min-width: 768px) {
  .banner-bg {
    display: flex;
  }
}
.banner-bg-img {
  width: 1690px;
  height: 600px;
  object-fit: cover;
}
.banner-inner {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 80px;
}
.banner-grid {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
  text-align: left;
}
@media (min-width: 768px) {
  .banner-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 48px;
  }
}
.banner-title {
  font-size: 20px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.2;
  margin-bottom: 12px;
}
@media (min-width: 768px) {
  .banner-title {
    font-size: 44px;
  }
}
.banner-subtitle {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.2;
  margin-bottom: 20px;
}
@media (min-width: 768px) {
  .banner-subtitle {
    font-size: 56px;
  }
}
.banner-desc {
  font-size: 13px;
  color: #666666;
  line-height: 1.625;
  margin-bottom: 24px;
  max-width: 560px;
}
@media (min-width: 768px) {
  .banner-desc {
    font-size: 15px;
  }
}

/* ---------- CTA 按钮（通用） ---------- */
.cta-btn {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s;
}
.cta-text {
  transition: transform 0.3s ease-out;
}
.cta-btn:hover .cta-text {
  transform: translateX(-4px);
}
.cta-arrow {
  position: absolute;
  right: 24px;
  opacity: 0;
  transform: translateX(8px);
  transition: all 0.3s ease-out;
}
.cta-btn:hover .cta-arrow {
  opacity: 1;
  transform: translateX(0);
}
.cta-black {
  background: #000000;
  color: #ffffff;
  padding: 10px 20px;
  font-size: 15px;
  width: 160px;
}
@media (min-width: 768px) {
  .cta-black {
    font-size: 16px;
    width: 180px;
  }
}

/* ---------- 模块2：AI智能体矩阵场景解决方案 ---------- */
.solutions-section {
  padding: 64px 0;
  background: #f9fafb;
  text-align: left;
}
@media (min-width: 768px) {
  .solutions-section {
    padding: 112px 0;
  }
}
.solution-list {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.solution-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) {
  .solution-card {
    flex-direction: row;
    height: 400px;
  }
}
.solution-info {
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media (min-width: 768px) {
  .solution-info {
    width: 50%;
    padding: 40px;
  }
}
.solution-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}
.solution-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
}
.solution-name {
  font-size: 18px;
  font-weight: 700;
  color: #0a0a0a;
  margin-bottom: 0;
}
@media (min-width: 768px) {
  .solution-name {
    font-size: 26px;
  }
}
.solution-desc {
  font-size: 15px;
  color: #666666;
  line-height: 1.625;
  margin-bottom: 24px;
}
.solution-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.solution-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #f9fafb;
  color: #0a0a0a;
  font-size: 14px;
  border-radius: 9999px;
}
.solution-case {
  width: 100%;
  position: relative;
  overflow: hidden;
}
@media (min-width: 768px) {
  .solution-case {
    width: 50%;
  }
}
.case-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.case-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.1) 100%);
}
.case-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 32px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: #ffffff;
}
@media (min-width: 768px) {
  .case-content {
    padding: 40px;
    padding-bottom: 16px;
  }
}
.case-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #fff;
}
.case-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.625;
  margin-bottom: 16px;
}
.case-stats {
  display: flex;
  gap: 24px;
}
.case-stat-value {
  font-size: 24px;
  font-weight: 700;
}
.case-stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

/* ---------- 合作伙伴定位 ---------- */
.position-section {
  padding: 64px 0;
  background: #ffffff;
}
@media (min-width: 768px) {
  .position-section {
    padding: 112px 0;
  }
}
.position-wrap {
  position: relative;
}
.position-head {
  text-align: center;
  margin-bottom: 24px;
}
@media (min-width: 768px) {
  .position-head {
    margin-bottom: 32px;
  }
}
.position-head .section-title {
  margin-bottom: 4px;
}
.position-head-desc {
  font-size: 14px;
  color: #666666;
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.625;
}
@media (min-width: 768px) {
  .position-head-desc {
    font-size: 16px;
  }
}

/* 桌面端：双方分工 */
.position-desktop {
  display: none;
  position: relative;
  margin-bottom: 48px;
  align-items: center;
  justify-content: space-between;
  min-height: 400px;
}
@media (min-width: 768px) {
  .position-desktop {
    display: flex;
  }
}
.position-side {
  flex: 1 1 0%;
  min-width: 0;
  max-width: 280px;
}
.position-side-left {
  padding-right: 16px;
}
.position-side-right {
  padding-left: 16px;
}
.position-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.position-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (min-width: 768px) {
  .position-item {
    padding: 14px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
}
.position-check {
  flex-shrink: 0;
}
.position-item-text {
  font-size: 14px;
  color: #0a0a0a;
}

/* 中间圆圈 */
.position-center {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.circle-wrap {
  position: relative;
}
.circle-glow {
  position: absolute;
  top: 50%;
  width: 450px;
  height: 320px;
  border-radius: 50%;
  pointer-events: none;
}
.circle-glow-purple {
  right: 30px;
  transform: translateY(-50%);
  background: radial-gradient(ellipse at right center, rgba(139, 92, 246, 0.18) 0%, transparent 70%);
}
.circle-glow-blue {
  left: 30px;
  transform: translateY(-50%);
  background: radial-gradient(ellipse at left center, rgba(59, 130, 246, 0.18) 0%, transparent 70%);
}
.partner-circle {
  position: relative;
  z-index: 10;
  width: 180px;
  height: 180px;
  border-radius: 9999px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
.circle-purple {
  background: #8b5cf6;
}
.circle-blue {
  background: #3b82f6;
}
.circle-name {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
}
.circle-sub {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  margin-top: 4px;
}
.plus-wrap {
  position: relative;
  z-index: 30;
  margin: 0 32px;
}
.plus-circle {
  width: 64px;
  height: 64px;
  border-radius: 9999px;
  background: #60a5fa;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1), 0 0 0 4px #ffffff;
}
.plus-circle span {
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
}

/* 移动端：双方分工 */
.position-mobile {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 64px;
}
@media (min-width: 768px) {
  .position-mobile {
    display: none;
  }
}
.mobile-list {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
}
.mobile-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  gap: 12px;
}
.mobile-item-text {
  font-size: 14px;
  color: #333333;
}
.mobile-circle {
  width: 140px;
  height: 140px;
  border-radius: 9999px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
.mobile-circle .circle-name {
  font-size: 18px;
}
.mobile-circle .circle-sub {
  font-size: 10px;
}
.mobile-plus {
  display: flex;
  justify-content: center;
}
.mobile-plus-circle {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  background: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 4px #ffffff;
}
.mobile-plus-circle span {
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}
.mobile-hitone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

/* 四类合作对象 */
.partner-types-head {
  text-align: center;
  margin-bottom: 32px;
  margin-top: -80px;
}
.partner-types-head h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0a0a0a;
}
@media (min-width: 768px) {
  .partner-types-head h3 {
    font-size: 20px;
  }
}
.types-divider {
  width: 32px;
  height: 2px;
  background: #0a0a0a;
  margin: 16px auto 0;
  border-radius: 9999px;
}
.partner-types-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
@media (min-width: 768px) {
  .partner-types-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
  }
}
.partner-type-card {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #f3f4f6;
}
.partner-type-imgbox {
  width: 100%;
  height: 160px;
  background: #e5e7eb;
  overflow: hidden;
}
.partner-type-imgbox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.partner-type-name {
  padding: 16px;
  text-align: center;
}
.partner-type-name h4 {
  font-size: 15px;
  font-weight: 500;
  color: #0a0a0a;
}
@media (min-width: 768px) {
  .partner-type-name h4 {
    font-size: 16px;
  }
}

/* ---------- 合作伙伴赋能 ---------- */
.empower-section {
  padding: 64px 0;
  background: #ffffff;
  position: relative;
  overflow: hidden;
}
@media (min-width: 768px) {
  .empower-section {
    padding: 112px 0;
  }
}
.empower-head {
  margin-bottom: 32px;
}
@media (min-width: 768px) {
  .empower-head {
    margin-bottom: 48px;
  }
}
.empower-head .section-title {
  margin-bottom: 16px;
}
.empower-main {
  position: relative;
  padding-bottom: 128px;
}
@media (min-width: 768px) {
  .empower-main {
    padding-bottom: 192px;
  }
}
.empower-ellipse {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 1300px;
  height: 260px;
  border-radius: 50%;
  pointer-events: none;
  bottom: 80px;
  background: linear-gradient(to top, #e8f0fe 0%, transparent 80%);
}
.empower-arrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -30px;
}
.empower-arrow img {
  width: 250px;
  height: 75px;
}
.empower-grid {
  position: relative;
  z-index: 10;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  padding-top: 32px;
}
@media (min-width: 768px) {
  .empower-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 24px;
  }
}
.empower-offset-1 {
  margin-top: 0;
}
.empower-offset-2 {
  margin-top: 0;
}
@media (min-width: 768px) {
  .empower-offset-1 {
    margin-top: 24px;
  }
  .empower-offset-2 {
    margin-top: 48px;
  }
}
.empower-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #f3f4f6;
  text-align: center;
}
.empower-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}
.empower-card h4 {
  font-size: 16px;
  font-weight: 700;
  color: #0a0a0a;
  margin-bottom: 8px;
}
.empower-card p {
  font-size: 14px;
  color: #666666;
  margin: 0;
}
.empower-badge {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  bottom: 56px;
  padding: 12px 48px;
  background: #3b82f6;
  border-radius: 9999px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}

/* ---------- 合作伙伴收益 ---------- */
.benefit-section {
  padding: 64px 0;
  background: #f7f8fa;
  text-align: left;
}
@media (min-width: 768px) {
  .benefit-section {
    padding: 112px 0;
  }
}
.benefit-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 24px;
}
@media (min-width: 768px) {
  .benefit-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.benefit-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #f3f4f6;
  height: 260px;
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) {
  .benefit-card {
    padding: 32px;
    height: 280px;
  }
}
.benefit-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #ffffff;
}
.benefit-card h4 {
  font-size: 18px;
  font-weight: 700;
  color: #0a0a0a;
  margin-bottom: 12px;
}
.benefit-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
}
.benefit-tag-wrap {
  margin-top: auto;
  padding-top: 16px;
}
.benefit-tag {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
}

/* ---------- 模块10：CTA ---------- */
.cta-section {
  height: 400px;
  background: #eef0f6;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cta-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.cta-bg img {
  width: 1600px;
  height: 400px;
  object-fit: cover;
  object-position: center;
}
.cta-content {
  position: relative;
  z-index: 10;
  text-align: center;
}
.cta-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin-bottom: 12px;
  line-height: 1.2;
}
@media (min-width: 768px) {
  .cta-title {
    font-size: 36px;
  }
}
.cta-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
}
@media (min-width: 768px) {
  .cta-desc {
    font-size: 16px;
  }
}
.cta-btn-wrap {
  margin-top: 24px;
}
@media (min-width: 768px) {
  .cta-btn-wrap {
    margin-top: 32px;
  }
}
.cta-dark {
  background: #0a0a0a;
  color: #ffffff;
  padding: 12px 24px;
  font-size: 15px;
  width: 220px;
}
@media (min-width: 768px) {
  .cta-dark {
    padding: 14px 28px;
    font-size: 16px;
    width: 240px;
  }
}
</style>
